import React, { useEffect, useState } from "react";
import { InputNumber } from "antd";
import { Currency } from "../../Payment/MultiplePaymentApp";
import ApiService from "../../../core/service/ApiService";
import CurrencySelect from "../../../core/components/CurrencySelect";

// block: kabı doldurur — tutar kalan yeri alır, para birimi sabit dar (mobil kart)
export const AppointmentEntitlementInput = ({ row, onSuccess, block = false }) => {
    const [data, setData] = useState({
        currency: 'TRY',
        amount: 0
    })

    useEffect(() => {
        setData({
            currency: row.entitlementCurrency || row.currency,
            amount: row.entitlementAmount
        })
    }, [row]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: block ? '100%' : undefined }}>
            <InputNumber
                size={'small'}
                style={block ? { flex: 1, minWidth: 0, width: 'auto' } : undefined}
                disabled={row?.confirmStatus === 2}
                value={data.amount}
                prefix={Currency[data.currency]}
                onPressEnter={async (e) => {
                    setData({
                        ...data,
                        amount: e.target.value
                    })
                    const res = await ApiService.Entitlement.UpdateEntitlement(row.appointmentId, {
                        amount: e.target.value,
                        currency: data.currency,
                        type: 'amount'
                    });

                    if (res.success) {
                        await onSuccess()
                    }
                }}
            />
            <CurrencySelect
                short={true}
                size={'small'}
                {...(block ? { style: { width: 84, flex: 'none' } } : {})}
                disabled={row?.confirmStatus === 2}
                value={data.currency}
                onChange={(e) => {
                    setData({
                        ...data,
                        currency: e,
                    })
                }}
            />
        </div>
    )
}